import { render, staticRenderFns } from "./Gallery24.vue?vue&type=template&id=ca8f0634&scoped=true&"
import script from "./Gallery24.vue?vue&type=script&lang=js&"
export * from "./Gallery24.vue?vue&type=script&lang=js&"
import style0 from "./Gallery24.vue?vue&type=style&index=0&id=ca8f0634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8f0634",
  null
  
)

export default component.exports